export default __webpack_public_path__ + "static/media/LTC.d76270cb.svg";